
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import wx from "weixin-js-sdk";
import global_ from "./global";

export default {
data() {
return {
showLoading: false,
photo: {path: "", serverid: ""},
account: "",
username: "",
sequence: "",
cont: "",
iden: "",
rateList: {
version: "1.0",
content: []
},
rate: [],
list: [],
imgList: [],
newobj: {
photo: []
},
num: 6,
show: true,
index: 0,
flag: true,
solutionv: this.$route.params.solutionv,
url: this.$route.params.url
};
},
components: {
XHeader,
XInput,
Group,
XAddress,
Card,
Alert,
Cell,
XButton
},
methods: {
fileDel(key) {
var index;
for (let j = 0; j < this.imgList.length; j++) {
if (this.imgList[j].path == key) {
this.imgList.splice(j, 1);
}
}

for (let i = 0; i < this.list.length; i++) {
if (this.list[i] == key) {
index = i;
this.list.splice(i, 1);
this.num++;
this.index--;
}
}
this.newobj.photo.splice(index, 1);
if (this.num < 6) {
this.show = true;
}
},
confirm() {
this.showLoading = true;
let header = {
headers: {
token: localStorage.getItem("token"),
opid: localStorage.getItem("userid")
}
};
if (this.solutionv === 1) {
let obj = {
role: this.iden,
solution: this.rateList,
solutionv: 1,
};
let that = this;
let arr = [];
if (this.cont !== "") {
let target = {
path: [],
describe: "",
time: ""
};
this.list.forEach(item => {
arr.push(item);
})
target.path = arr;
target.describe = (this.orderDetail.expert ? this.orderDetail.expert.name : this.orderDetail.responsible.name) + '--' + this.cont; 
var date = new Date();
var year = date.getFullYear();
var month = date.getMonth() + 1;
var d = date.getDate();
var hours = date.getHours();
var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
target.time = year + "-" + month + "-" + d + " " + hours + ":" + minutes + ":" + seconds;

if (this.rate != null) {
for (let i = 0; i < this.rate.length; i++) {
this.rateList.content.push(this.rate[i]);
}
}
this.rateList.content.unshift(target);
that.$http.put("/api/v1/normalrepairs/" + this.orderDetail.seq + "/solution", obj, header)
.then((res) => {
if (that.url) {
that.$router.push({name: this.url, query: {seq: this.orderDetail.seq}});
} else {
switch (this.iden) {
case "EXPT":
that.$router.push({name: "records", query: {seq: this.orderDetail.seq}});
break;
case "SRVP":
that.$router.push({name: "RepairOrder", params: {isAdmin: false}});
break;
case "ADMIN":
that.$router.push({name: "RepairOrder", params: {isAdmin: true}});
break;
}
}

})
.catch(error => {
this.showLoading = false
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
} else {
this.showLoading = false
this.$vux.alert.show({
title: "",
content: "描述信息不能为空"
});
}
} else {
let path = [];
this.list.forEach(item => {
path.push(item)
})
let obj = {
role: this.iden,
solutionv: 2,
record: this.cont,
path
}
this.$http.put("/api/v1/normalrepairs/" + this.orderDetail.seq + "/solution", obj, header)
.then((res) => {
if (this.url) {
this.$router.push({name: this.url, query: {seq: this.orderDetail.seq, role: 'EXPT'}});
} else {
this.$router.push({name: "records", query: {seq: this.orderDetail.seq}});
}
})
.catch(error => {
this.showLoading = false
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
}

},
upload: function () {
var app = this;

var obj = {
photo: []
};

wx.chooseImage({
count: app.num, // 默认9
sizeType: ["compressed"],
sourceType: ["album", "camera"],
success: function (res) {
var localIds = res.localIds; 

var i = 0;
length = localIds.length;
var upload = function () {
wx.uploadImage({
localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: function (res) {
app.flag = false;
if (app.list.length == 0) {
app.newobj.photo.push(res.serverId);
} else {
obj.photo.push(res.serverId);
}
i++;
app.num--;
if (i < length) {
upload();
} else {

if (app.list.length == 0) {
app.submitImage(app.newobj);
} else {
app.submitImage(obj);
}
}
}
});
};
upload();
}
});
},
submitImage(obj) {
var app = this;
let token = localStorage.getItem("token");
let opid = localStorage.getItem("userid");
var header = {
headers: {
token: token,
opid: opid
}
};
AjaxPlugin.$http.post("/api/v1/photos/wechat", obj, header)
.then((response) => {
app.flag = true;
if (app.list.length === 0) {
app.list = response.data;
app.decrypt();
} else {
for (let i = 0; i < response.data.length; i++) {
app.list.push(response.data[i]);
}
app.decrypt();
}
if (app.list.length === 6) {
app.show = false;
}
})
.catch(function (error) {
app.flag = true;
if (error.response) {
app.$vux.loading.hide();
if (error.response.data.error_message) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
} else {
app.$vux.toast.show({
text: "服务器错误，请稍后重试",
type: "cancel",
time: "1000"
});
}
} else {
app.$vux.loading.hide();
app.$vux.toast.show({
text: "服务器错误，请稍后重试",
type: "cancel",
time: "1000"
});
console.log("Error", error.message);
}
});
},
decrypt() {
let token = localStorage.getItem("token");
let opid = localStorage.getItem("userid");
var header = {
headers: {
token: token,
opid: opid
}
};
AjaxPlugin.$http.get("api/v1/photos?path=" + this.list[this.index].thumb, header)
.then(res => {
this.imgList.push(res.data);
this.index++;
if (this.index < this.list.length) {
this.decrypt();
}
});
}
},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000);
var url;
var u = navigator.userAgent;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
var app = this;
app.$http.get("static/config.json").then(
response => {
var config = response.data;
if (isiOS) {
url = config.host + global_.entryUrl;
} else {
url = config.host + app.$route.path;
}
var noncestr = Math.random().toString(36).substr(2);
app.$http.get("/api/v1/wechat/jsApiTicket?timestamp=" + timestamp + "&noncestr=" + noncestr + "&url=" + url)
.then((response) => {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: [
"chooseImage",
"previewImage",
"uploadImage",
"downloadImage",
"translateVoice",
"getLocalImgData",
"checkJsApi"
] // 必填，需要使用的JS接口列表
});
wx.error(function (res) {

});
})
.catch(function (error) {

if (error.response) {
console.log(error.response.data);
} else if (error.request) {
console.log(error.request);
} else {
console.log("Error", error.message);
}
});
},
response => {
console.log("数据加载失败");
}
);
}, 500);
},
created() {
var that = this
var order = localStorage.getItem("order");
this.orderDetail = JSON.parse(order);
this.rate = this.$route.params.rate;
console.log(this.rate)

var opid = localStorage.getItem("userid");
var obj = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
this.$http.get("/api/v1/accounts/" + opid, obj).then(function (res) {
for (let i = 0; i < res.data.length; i++) {
if (res.data[i].type == "EXPT") {
that.iden = "EXPT";
}
if (res.data[i].type == "SRVP") {
that.iden = "SRVP";
}
if (res.data[i].type == "ADMIN") {
that.iden = "ADMIN";
}
}
});
},
beforeRouteLeave(to, from, next) {
if (to.name === 'makeMemo') {
to.params.solutionv = this.solutionv
}
next()
}
};



// WEBPACK FOOTER //
// ./src/components/addrate.vue